var accordions = [].slice.call(document.querySelectorAll('.accordion button'));

accordions.forEach(function(accordion) {
	accordion.addEventListener('click', function() {
		var answer = this.nextSibling,
			animation = window.getComputedStyle(answer).display == 'block' ? 'slideUp' : 'slideDown';

		closeAccordion(this);

		Velocity(answer, animation, {duration: 250});

		this.classList.toggle('open');

		this.setAttribute('aria-expanded', (this.getAttribute('aria-expanded') == 'true' ? 'false' : 'true'));

		// setTimeout(function() {
		// 	scrollToElement(this.parentNode);
		// }, 250);
	});
});

function closeAccordion(el) {
	var openAccordion = el.parentElement.parentElement.querySelector('.open');

	if(openAccordion && openAccordion !== el) {
		Velocity(openAccordion.nextSibling, 'slideUp', {duration: 250});

		openAccordion.classList.toggle('open');
	}
}